import { Box } from "@cjdev-internal/visual-stack-x/Box";
import { Text } from "@cjdev-internal/visual-stack-x/Text";
import { useIntl } from "hooks";
import React from "react";
import messages from "../messages";
import { DateMetric, EngagementMetric, NumericMetric } from "../metrics";
import { MetricsGrid } from "../MetricsGrid";

export const FacebookMetrics = ({ metrics }) => {
  const intl = useIntl();
  return (
    <Box direction="column" gap="xl">
      <MetricsGrid>
        <NumericMetric name="pageLikes" value={metrics.pageLikes} />
        <DateMetric name="lastPostDate" value={metrics.lastPostDate} />
        <NumericMetric name="postLikes" value={metrics.postLikes} />
        <NumericMetric name="totalComments" value={metrics.totalComments} />
        <NumericMetric name="numberOfPosts" value={metrics.numberOfPosts} />
      </MetricsGrid>
      <Box direction="column" gap="medium">
        <Text weight="medium" size={14}>
          {intl.formatMessage(messages.timePeriodLast20Posts)}
        </Text>
        <MetricsGrid>
          <EngagementMetric
            label={metrics.engagementLabel}
            rate={metrics.engagementRate20Posts}
            socialPlatform="facebook"
          />
          <NumericMetric
            name="likesPerPost20Posts"
            value={metrics.likesPerPost20Posts}
          />
          <NumericMetric
            name="commentsPerPost20Posts"
            value={metrics.commentsPerPost20Posts}
          />
        </MetricsGrid>
      </Box>
    </Box>
  );
};
